import { Route, useLocation } from 'react-router';
import { LibxFeaturedEntryPage } from './LibxFeaturedEntryPage';
import { PageNotFound } from '../../shop/PageNotFound';
import { LibxGenresContainer } from './genres/LibxGenresContainer';
import LibxProductDetailPage from './productdetail/LibxProductDetailPage';
import { LocalRegionsPage } from './localregions/LocalRegionsPage';
import { NewlyAddedPage } from './NewlyAddedPage';
import { AllTitlesPage } from './AllTitlesPage';
import { MULTI_LANGUAGE_SHOP, useFeature } from '../../shared/utils/togglz';
import { LocalRegionsRedirect } from './localregions/LocalRegionsRedirect';
import { useAgeCategorySearchParam } from '../../shared/utils/useAgeCategorySearchParam';
import { Navigate, Routes } from 'react-router-dom';

const LibxRouteSwitch = () => {
    const { pathname, search } = useLocation();
    const isMultiLanguageShopEnabled = useFeature(MULTI_LANGUAGE_SHOP);
    const { searchParam: ageCategorySearchParam } = useAgeCategorySearchParam();
    const searchParams = new URLSearchParams(ageCategorySearchParam ? { ageCategory: ageCategorySearchParam } : {});

    if (isMultiLanguageShopEnabled) {
        return (
            <Routes>
                <Route path="products/:productId" element={<LibxProductDetailPage />} />
                <Route path="*" element={<Navigate to={{ pathname: `/shop/en${pathname}`, search }} replace />} />
            </Routes>
        );
    }

    return (
        <Routes>
            <Route
                index
                element={<Navigate to={{ pathname: 'featured', search: searchParams.toString() }} replace />}
            />
            <Route path="products">
                <Route index element={<AllTitlesPage />} />
                <Route path=":productId" element={<LibxProductDetailPage />} />
            </Route>
            <Route path="featured" element={<LibxFeaturedEntryPage />} />
            <Route path="newlyadded" element={<NewlyAddedPage />} />
            <Route path="genres/:genre?/:subgenre?" element={<LibxGenresContainer />} />
            <Route path="localregions">
                <Route index element={<LocalRegionsRedirect />} />
                <Route path=":level1/:level2?" element={<LocalRegionsPage />} />
            </Route>
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
};

export default LibxRouteSwitch;
